export default __webpack_public_path__ + "static/media/item-1.a41b183a.jpg";